module.exports = __webpack_public_path__ + "static/img/source-m@2x.20cc4ec6.png";